module.exports = __webpack_public_path__ + "static/img/bg-overview@t.2c63ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/bg-overview@t.jpg
// module id = xuuu
// module chunks = 0